<template>
  <el-dialog
    title="新增费用"
    :visible.sync="visible"
    width="1200px"
    @close="close"
    :close-on-click-modal="false">
    <div style="text-align: right; padding: 0 16px 16px 0; background: white;">
      <el-button :loading="btnLoading" type="primary" icon="el-icon-s-release" size="mini" @click="saveData">暂存</el-button>
      <el-button :loading="btnLoading" type="primary" icon="el-icon-success" size="mini" @click="submitData">提交</el-button>
<!--      <el-button :loading="btnLoading" type="primary" icon="el-icon-close" size="mini" @click="close">关闭</el-button>-->
    </div>
    <div style="padding: 16px;">
      <CureOutlayDetail
        ref="outlayDetail"
        :showCase="true"
        :helpId="helpId"
        :outlayId="outlayId"
        :helpReqId="helpReqId"
        :belongProject="'AY1002'"
        :readOnly="false"
        :addAngleStages="true"
        @beforeSave="btnLoading = true"
        @saveComplete="btnLoading = false"
        @success="success"
        @close="close">
      </CureOutlayDetail>
    </div>
  </el-dialog>
</template>

<script>
import CureOutlayDetail from "@/pages/outlay/cure/CureOutlayDetail";

export default {
  components: {
    CureOutlayDetail,
  },
  props: {
    visible: false,
    outlayId: String,
    helpId: String,
    helpReqId: String
  },
  data () {
    return {
      btnLoading: false
    }
  },
  methods: {
    saveData () {
      this.$refs.outlayDetail.saveData();
    },
    submitData () {
      this.$refs.outlayDetail.submitData();
    },
    success () {
      this.$emit('success');
      this.close()
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/common/form";
</style>



// WEBPACK FOOTER //
// src/pages/child/manage/HelpOutlayAdd.vue